import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import UserForm from './UserForm';

function Users() {
    return ( 
        <Container>
            <Navbar/>

            <Content>

             <UserForm/>
            </Content>
        </Container>
     );
}

export default Users;